import { ListFlowState } from '@sls-react/store/listFlow/ui';
import getQueryClient from '@sls-react/utils/getQueryClient';
import fireAnalytics from '@sls-react/services/analytics/fireAnalytics';
import { RailsSessionUser } from '@sls-react/typings/services/rails/session';
import getEnv from '@sls-react/utils/getEnv';
import { fetchReferralCode } from '@sls-react/api/sellerAccount';
import sha1 from 'js-sha1';
import { RailsItem } from '@sls-react/typings/services/rails/item';

export const fireVisitedListFlow = () => fireAnalytics('Visited List Item');

export const fireListedItem = async (
  item: RailsItem,
  state?: ListFlowState,
) => {
  const queryClient = getQueryClient();
  const { user } =
    queryClient.getQueryData<{ user: RailsSessionUser }>('v1-session') || {};
  const valueGuide =
    queryClient.getQueryData('list-flow-value-guide', {
      active: true,
      exact: false,
    }) || {};

  const listCount = user?.properties.list_count;

  const analyticsOptions = {
    category: item.categories[0]?.slug,
    item_id: item.id,
    list_price: item.price,
    // role: yield select(amIAdmin) ? 'admin' : 'seller',
    discount_amount: item.shipping_discount_amount,
    discount_label: state?.shipping.discount?.label,

    value_guide_visible: !!valueGuide,
    auto_price_drop: !!state?.pricing?.autoPriceDrop?.enabled,
  };

  if (typeof window !== 'undefined' && user) {
    let referralCode;

    const ireParams: any = {
      orderId: item.id,
      customerId: user.external_id,
      customerStatus: listCount! > 0 ? 'Returning' : 'New',
      customerEmail: sha1(user.email),
      items: [
        {
          category: item.categories[0]?.full_name,
          sku: item.id,
          quantity: item.quantity,
          subTotal: item.price,
          name: item.name,
        },
      ],
    };

    try {
      referralCode = await fetchReferralCode();
      if (referralCode.referral_code) {
        ireParams.orderPromoCode = referralCode.referral_code;
      }
    } catch (e) {}

    window.ire?.('trackConversion', 22093, ireParams);

    if (getEnv() !== 'production') {
      console.log('IRE PARAMS', ireParams);
    }
  }

  fireAnalytics('Listed Item', null, analyticsOptions);
};
